export default __webpack_public_path__ + "static/logo-orange-6862496eaa004443f66ab8105a2d6034.png";